'use strict';

var _ = require('lodash');
var Draw = require('./Draw');

var DrawRectangle = Draw.extend({
  constructor: function (map, options, Actions, Store) {
    var DEFAULT_OPTIONS = {
      shapeOptions: options.styles.default
    };

    this.drawOptionKeys = [
      'repeatMode',
      'shapeOptions',
    ];

    options = _.extend(DEFAULT_OPTIONS, options);
    Draw.call(this, map, options, Actions, Store);
  },

  _newDraw: function (options) {
    var map = this.map;
    return new L.Draw.Rectangle(map, options);
  }
});

module.exports = DrawRectangle;


// WEBPACK FOOTER //
// ./~/@skycatch/skydash-saturn/boosters/map/src/app/layer/draw/handlers/DrawRectangle.js